import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useMutation } from "react-query";
import { useLocation, useNavigate } from "react-router-dom";
import { confirmEmail } from "../services/auth.service";
import useSnackbarStore from "../store/snackbarStore";
import mixpanel from "mixpanel-browser";
import useUserStore from "../store/useUser.store";
import useSessionStore from "../store/useSessionStore";
import useChatGPTStore from "../store/useChatGPT.store";
import useUsageStore from "../store/useUsageStore";
import { useMixPanel } from "../hooks/useMixPanel";
import { MIX_PANEL_EVENTS } from '../utils/constans';

const ConfirmEmail = () => {
  const [loading, setLoading] = useState(false);
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const { show } = useSnackbarStore();
  const { setClear } = useSessionStore();
  const { setLang } = useUserStore();
  const { setClear: setClearChatGTPStore } = useChatGPTStore();
  const { setClear: setClearUseCaseUsageStore } = useUsageStore();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");
  const userString = localStorage.getItem("user");
  const userObject = userString ? JSON.parse(userString) : {};
  const navigate = useNavigate();
  const { setManualEvent } = useMixPanel();

  const forceLogout = () => {
    mixpanel.track(
      "SHAIA_LOGOUT",
      {
        email: userObject?.email,
      },
      {
        send_immediately: true,
      },
      () => {
        mixpanel.reset();
      }
    );
    i18n.changeLanguage("es");
    setLang("es");
    localStorage.clear();
    localStorage.setItem("lang", "es");
    navigate("/login");
    setClear();
    setClearChatGTPStore();
    setClearUseCaseUsageStore();
  };

  const teacherSessionMutation = useMutation(confirmEmail, {
    onSuccess: (data) => {
      setManualEvent(data?.user, MIX_PANEL_EVENTS.confirmedEmail);
      if (userObject?.email !== data?.user.email) {
        forceLogout();
        show(t("correo_confirmado_usuario_no_existe"));
      } else {
        show(t("correo_confirmado_usuario_existe"));
        navigate("/");
      }
      
    },
    onError: () => {},
  });

  useEffect(() => {
    if (token) {
      setLoading(true);
      teacherSessionMutation.mutate(token);
    }
    // eslint-disable-next-line
  }, [token]);

  return (
    <>
      <div className="text-white">
        {loading ? "Confirmando correo ..." : "Condirmado"}
      </div>
    </>
  );
};

export default ConfirmEmail;
